let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cG5ST")).then(() => parcelRequire('cIsnC'));